import { MarketPlaceCategoryDto } from './MarketPlaceCategoryDto';

export class MarketPlaceAiProcessDto {
    category: MarketPlaceCategoryDto;
    parents: MarketPlaceCategoryDto[] = [];
    explanation: string | null = null;

    constructor(category: MarketPlaceCategoryDto) {
        this.category = category;
    }
}